import { UseCase } from '../UseCase';
import { GetAccessToken } from './GetAccessToken';
import { ParseAccessToken } from './ParseAccessToken';
import { SetAccessToken } from './SetAccessToken';

export class CheckAccessToken implements UseCase<Location, boolean> {
    private getAccessToken = new GetAccessToken();
    private setAccessToken = new SetAccessToken();
    private parseAccessToken = new ParseAccessToken();

    execute(location: Location): boolean {
        let access = this.parseAccessToken.execute(location);
        if (access) {
            this.setAccessToken.execute(access);
        } else {
            access = this.getAccessToken.execute();
        }

        if (access && Date.now() < access.jwt.exp * 1000) {
            return true;
        } else {
            return false;
        }
    }
}
